<template>
  <!--begin::Basic info-->
  <div class="card mb-5 mb-xl-10">
    <!--begin::Content-->
    <EditFitur></EditFitur>
    <!--end::Content-->
  </div>
</template>
<script>
import EditFitur from "@/components/1crm/fitur/master-fitur/edit.vue";
import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "add-master-fitur",
  components: {
    EditFitur,
  },
  setup() {
    const store = useStore();

    onMounted(() => {
      store.dispatch(Actions.VERIFY_AUTH_SEKOLAH);
      setCurrentPageBreadcrumbs("Detail Master Fitur", ["Management Fitur", "Master Fitur"]);
    });
  },
});
</script>
